import React, { useState } from "react";
import { startOfDay, endOfDay, format as formatDate } from "date-fns";

import styles from "./ExportFilesModal.module.css";
import ReactModal from "react-modal";
import Icon from "../Icon/Icon";

import Calendar from "../Calendar/Calendar";

import api from "../../api/api";

type CreatePropertyModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
};

const ExportFilesModal = ({
  isOpen,
  onRequestClose,
}: CreatePropertyModalProps) => {
  const [selectedDateFrom, setSelectedDateFrom] = useState<Date | undefined>();
  const [selectedDateTo, setSelectedDateTo] = useState<Date | undefined>();

  const handleExportData = async () => {
    const dateFrom = selectedDateFrom
      ? formatDate(startOfDay(selectedDateFrom), "yyyy-MM-dd'T'00:00:00")
      : undefined;
    const dateTo = selectedDateTo
      ? formatDate(endOfDay(selectedDateTo), "yyyy-MM-dd'T'23:59:59.999")
      : undefined;
    const blob = await api.exportFilesToExcel({
      dateFrom,
      dateTo,
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "document-types.xlsx";
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleExportData();
    closeModal();
  };

  const closeModal = () => {
    onRequestClose();
    setSelectedDateFrom(undefined);
    setSelectedDateTo(undefined);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className={styles.modal}
      overlayClassName={styles.overlay}
      ariaHideApp={false}
    >
      <div className={styles.headContainer}>
        {" "}
        <h2 className={styles.title}>
          Copia de seguridad <Icon name="download" size={32} />{" "}
        </h2>
        <button className={styles.closeIcon} onClick={closeModal}>
          <Icon name="x-mark" size={18} />
        </button>
      </div>
      <p className={styles.subtitle}>
        Crea una copia de seguridad de forma manual, seleccionando el periodo y
        las ubicación de destino que desees
      </p>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.label}>
          Selecciona el periodo de tiempo
          <div className={styles.datePickersContainer}>
            <div className={styles.datePicker}>
              Desde
              <Calendar
                maxDate={selectedDateTo}
                wraperClassName={styles.datePickerWrapper}
                pickerClassName={styles.picker}
                selectedDate={selectedDateFrom}
                setSelectedDate={setSelectedDateFrom}
              />
            </div>
            <div className={styles.datePicker}>
              Hasta
              <Calendar
                minDate={selectedDateFrom}
                wraperClassName={styles.datePickerWrapper}
                pickerClassName={styles.picker}
                selectedDate={selectedDateTo}
                setSelectedDate={setSelectedDateTo}
              />
            </div>
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <button className={styles.cancelButton} onClick={closeModal}>
            Cancelar
          </button>
          <button type="submit" className={styles.submitButton}>
            Generar Copia <Icon name="stars" size={20} />
          </button>
        </div>
      </form>
    </ReactModal>
  );
};

export default ExportFilesModal;
